<template>
  <Form
    ref="form"
    class="mt-4"
    :validation-schema="schema"
    @submit="onSubmit"
    v-slot="{ errors }"
  >
    <div>
      <div class="form-group">
        <label for="emailInput">Email address</label>
        <Field
          name="email"
          class="form-control mb-0"
          :class="{ 'is-invalid': errors['email'] }"
          id="emailInput"
          v-model="user.email"
          placeholder="Enter email"
        />
        <div class="invalid-feedback">
          <ErrorMessage name="email" />
        </div>
      </div>
    </div>
    <div>
      <div class="form-group">
        <label for="passwordInput">Password</label>
        <router-link to="/auth/password-reset1" class="float-right">
          Forgot password?
        </router-link>
        <Field
          name="password"
          class="form-control mb-0"
          :class="{ 'is-invalid': errors['password'] }"
          id="passwordInput"
          type="password"
          v-model="user.password"
          placeholder="Password"
        />
        <div class="invalid-feedback">
          <ErrorMessage name="password" />
        </div>
      </div>
    </div>
    <div class="d-inline-block w-100">
      <div class="custom-control custom-checkbox d-inline-block mt-2 pt-1">
        <input
          type="checkbox"
          v-model="shouldRemember"
          class="custom-control-input"
          :id="formType"
        />
        <label class="custom-control-label" :for="formType">Remember Me</label>
      </div>
      <br />
      <span v-if="error">{{ error }}</span>
      <button type="submit" class="btn btn-primary float-right">Sign in</button>
    </div>
    <div class="sign-info">
      <span class="dark-color d-inline-block line-height-2">
      <social-login-form @showModal="showModal = true"></social-login-form>
    </span>
    </div>
    <div class="sign-info">
      <span class="dark-color d-inline-block line-height-2">
        Don't have an account?
        <router-link
          to="/dark/auth/sign-up1"
          class="iq-waves-effect pr-4"
          v-if="$route.meta.dark"
        >
          Sign up
        </router-link>
        <router-link to="/auth/sign-up1" class="iq-waves-effect pr-4" v-else>
          Sign up
        </router-link>
      </span>
    </div>
  </Form>
</template>

<script>
import SocialLoginForm from './SocialLoginForm'
import { Field, Form, ErrorMessage } from 'vee-validate'
import * as yup from 'yup'
import firebaseService from '../../../../../firebase'
import {
  signInWithEmailAndPassword,
  browserSessionPersistence,
  browserLocalPersistence,
  setPersistence
} from 'firebase/auth'
import { doc, getDoc } from 'firebase/firestore'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

export default {
  name: 'SignIn1Form',
  components: { SocialLoginForm, Field, Form, ErrorMessage },
  props: ['formType', 'email', 'password'],
  setup () {
    const schema = yup.object({
      email: yup.string().required().email(),
      password: yup.string().required().min(8)
    })
    const user = ref({
      email: '',
      password: ''
    })
    const shouldRemember = ref(false)
    const showModal = ref(false)
    const router = useRouter()
    const error = ref(null)

    const onSubmit = async (submittedObject) => {
      error.value = null
      if (shouldRemember) {
        await setPersistence(
          firebaseService.firebaseAuth,
          browserLocalPersistence
        )
      } else {
        await setPersistence(
          firebaseService.firebaseAuth,
          browserSessionPersistence
        )
      }
      signInWithEmailAndPassword(
        firebaseService.firebaseAuth,
        submittedObject.email,
        submittedObject.password
      )
        .then(async (userCredential) => {
          const docRef = doc(firebaseService.db, 'doctors', userCredential.user.uid)
          const usersRef = doc(firebaseService.db, 'users', userCredential.user.uid)

          const docSnapshot = await getDoc(docRef)
          if (docSnapshot.exists()) {
            const data = docSnapshot.data()
            if (data.isVerified) {
              router.push('/')
            } else {
              alert('Your account is not verified yet. Please contact Texavie to verify your status.')
              await firebaseService.firebaseAuth.signOut()
            }
          } else {
            const userSnapshot = await getDoc(usersRef)
            if (userSnapshot.exists()) {
              if (userSnapshot.data().isAuthorized) {
                router.push('/patient-home')
              } else {
                router.push('/customer/preorders')
              }
            } else {
              router.push('/admin')
            }
          }
        })
        .catch((err) => {
          console.log(err.message)
          error.value = 'Incorrect email or password'
        })
    }

    return { schema, user, shouldRemember, showModal, onSubmit, error }
  }
}
</script>
